import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Tilsætningsstoffer',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfam K',
    [ProductAdditives.AceSucralose]: 'Ace-sucralose',
    [ProductAdditives.Aesculin]: 'Aesculin',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Anthocyan',
    [ProductAdditives.Antioxidant]: 'Antioxidant',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidant: Ascorbinsyre',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidant: Tocopheroler',
    [ProductAdditives.Flavor]: 'Aroma',
    [ProductAdditives.Flavors]: 'Aromaer',
    [ProductAdditives.AscorbicAcid]: 'Ascorbinsyre',
    [ProductAdditives.Aspartame]: 'Aspartam',
    [ProductAdditives.OysterSauce]: 'Østerssauce',
    [ProductAdditives.BakingAid]: 'Bagehjælp',
    [ProductAdditives.BakingPowder]: 'Bagepulver',
    [ProductAdditives.BalsamicVinegar]: 'Balsamicoeddike',
    [ProductAdditives.BalsamicCream]: 'Balsamicocreme',
    [ProductAdditives.BasilPesto]: 'Basilikumpesto',
    [ProductAdditives.BenzoicAcid]: 'Benzoesyre',
    [ProductAdditives.BetaCarotene]: 'Betacaroten',
    [ProductAdditives.Betain]: 'Betain',
    [ProductAdditives.BeetrootRed]: 'Rødbedefarve',
    [ProductAdditives.Beeswax]: 'Bivoks',
    [ProductAdditives.Bitters]: 'Bitter',
    [ProductAdditives.BlueCuracao]: 'Blå curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Blå curaçao-sirup',
    [ProductAdditives.BrandyVinegar]: 'Brandyeddike',
    [ProductAdditives.Broth]: 'Bouillon',
    [ProductAdditives.Caffeine]: 'Koffein',
    [ProductAdditives.Calcium]: 'Calcium',
    [ProductAdditives.Caramel]: 'Karamel',
    [ProductAdditives.CaramelColor]: 'Karamelfarve',
    [ProductAdditives.CaramelE150d]: 'Karamel E150d',
    [ProductAdditives.Carotene]: 'Caroten',
    [ProductAdditives.CayennePepper]: 'Cayennepeber',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Chilidressing',
    [ProductAdditives.ChiliMayonnaise]: 'Chilimayonnaise',
    [ProductAdditives.ChiliOil]: 'Chiliolie',
    [ProductAdditives.Quinine]: 'Kinin',
    [ProductAdditives.Chlorophyll]: 'Klorofyl',
    [ProductAdditives.CitricAcid]: 'Citronsyre',
    [ProductAdditives.CitrusAcid]: 'Citrussyre',
    [ProductAdditives.CarbonDioxide]: 'Kuldioxid (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Cocktailsauce',
    [ProductAdditives.Curry]: 'Karry',
    [ProductAdditives.CurryPaste]: 'Karrypasta',
    [ProductAdditives.CurryPowder]: 'Karrypulver',
    [ProductAdditives.CurryCreamSauce]: 'Karrycremesauce',
    [ProductAdditives.Fragrance]: 'Duftstof',
  },
};
